import { useEffect } from "react";
import getEnv from "env";
import { isLocalhost } from "utils/helpers/browser";

const useDocumentTitle = (title: string | null) => {
  useEffect(() => {
    if (title) {
      const env = getEnv();
      document.title =
        isLocalhost() && env.multitenancyEnabled !== "true"
          ? `${title} - ${env.platformTenant.toUpperCase()}`
          : title;
    }
  }, [title]);
};

export default useDocumentTitle;
